import { Tooltip } from '@material-ui/core';
import CSS from 'csstype';
import React, { useState } from 'react';

import { PauseIcon, RefreshCycleIcon } from '~/src/dash/components/icons/misc-icons';
import { TrendsPillIcon } from '~/src/dash/components/icons/pill-icons';
import { FONT_WEIGHT } from '~/src/dash/components/text/common';
import { Col, Cols, fontSizing, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

type ToggleIconSlug = 'pause' | 'refresh' | 'trends';

interface ISortIconProps {
  color: string;
  iconSlug?: ToggleIconSlug;
}

const ToggleIcon = ({ color, iconSlug }: ISortIconProps) => {
  switch (iconSlug) {
    case 'pause':
      return <PauseIcon color={color} style={{ height: '11px' }} />;
    case 'refresh':
      return <RefreshCycleIcon color={color} />;
    case 'trends':
      return <TrendsPillIcon color={color} />;
    default:
      return <></>;
  }
};

interface IIconTextToggleProps {
  activeBackgroundColor?: string;
  activeColor?: string;
  buttonStyle?: CSS.Properties;
  defaultBackgroundColor?: string;
  defaultColor?: string;
  handleOnClick: () => void;
  hoverBackgroundColor?: string;
  hoverColor?: string;
  iconSlug?: ToggleIconSlug;
  isActive: boolean;
  label: string;
  textStyle?: CSS.Properties;
  tooltip?: string | JSX.Element;
}

export const IconTextToggle = ({
  activeBackgroundColor = publicaColors.honeydew,
  activeColor = publicaColors.jungleGreen,
  buttonStyle = {},
  defaultBackgroundColor = publicaColors.veryLightGray,
  defaultColor = publicaColors.black,
  handleOnClick,
  hoverBackgroundColor = publicaColors.lightGray,
  hoverColor = publicaColors.black,
  iconSlug,
  isActive,
  label,
  textStyle = {},
  tooltip = '',
}: IIconTextToggleProps) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  const color = isActive ? activeColor : isHovered ? hoverColor : defaultColor;

  const backgroundColor = isActive
    ? activeBackgroundColor
    : isHovered
    ? hoverBackgroundColor
    : defaultBackgroundColor;

  return (
    <Tooltip title={tooltip}>
      <button
        style={{
          display: 'inline-block',
          borderWidth: 0,
          margin: 0,
          padding: '6px 16px',
          borderRadius: '6px',
          backgroundColor,
          fontFamily: 'inherit',
          whiteSpace: 'nowrap',
          cursor: 'pointer',
          ...buttonStyle,
        }}
        onClick={() => handleOnClick()}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Cols
          gap='4px'
          style={{
            alignItems: 'center',
          }}
        >
          {iconSlug && (
            <Col displayFlex style={{ minWidth: '14px' }}>
              <ToggleIcon color={color} iconSlug={iconSlug} />
            </Col>
          )}
          <Col>
            <Text
              disableSelect
              style={{
                color,
                lineHeight: 'inherit',
                fontStyle: 'inherit',
                fontSize: fontSizing.small,
                fontWeight: FONT_WEIGHT.bold,
                ...textStyle,
              }}
            >
              {label}
            </Text>
          </Col>
        </Cols>
      </button>
    </Tooltip>
  );
};
